import { textStyleCss } from 'src/theme/atlas';
import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const DisclosureResponsesSectionContainer = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.atlas.core.spacing[3]};

  h3 {
    margin: 0 0 16px;
    ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)}
    color: ${(props) => props.theme.atlas.semantic.color.type.default};
  }

  h4 {
    margin: 16px 0 8px;
    ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
    font-weight: 600;
    color: ${(props) => props.theme.atlas.semantic.color.type.muted};
  }
`;

export const DisclosureResponsesList = styled.div`
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.atlas.core.spacing[3]};

  & > * {
    animation: ${fadeIn} 0.3s ease-in;
  }
`;

export const ResponseSectionHeading = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.atlas.core.spacing[2]};
`;

export const ResponseSectionHeadingTitle = styled.div`
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.headingH4)}
`;
